import { Component, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserService } from '@app/core/http-services/user.service';
import { GlobalErrorHandlerService } from '@app/core/services';
@Component({
  selector: 'app-mfa-security',
  templateUrl: './mfa-security.component.html',
  styleUrls: ['./mfa-security.component.scss'],
})
export class MfaSecurityComponent implements OnInit, OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>();
  @ViewChild('container', { read: ViewContainerRef })
  public container: ViewContainerRef;
  userDetails: any;
  loader: boolean = false;
  currentUserData: any;
  securityBreadcrumbs: any = [
    {
      label: 'Security',
      active: true,
    },
  ];
  isOtpSet: boolean = false;
  isGuardianSet: boolean = false;
  isPhoneSet: boolean = false;
  isEmailSet: boolean = false;
  constructor(private userService: UserService, private errorHandler: GlobalErrorHandlerService) {}
  async ngOnInit() {
    this.userDetails = await this.userService.getUserDetails();
    this.getProfile(this.userDetails?.sub);
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  /**
   * Get user profile details
   */
  getProfile(userId) {
    this.loader = true;
    this.userService
      .getUserProfile(userId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          if (response) {
            this.currentUserData = response;
          }
          this.loader = false;
        },
        (err) => {
          this.loader = false;
          this.errorHandler.apiErrorHandle(err);
        }
      );
  }
}
